import api from './api';

export interface Stats {
  activeSellers: number;
  productsSold: number;
  happyCustomers: number;
  avgRating: number;
}

export interface DashboardStats {
  totalPurchases: number;
  totalSales: number;
  totalEarnings: number;
  averageRating: number;
}

export const statsService = {
  /**
   * Get platform statistics
   */
  async getStats(): Promise<Stats> {
    const response = await api.get('/stats');
    return response.data;
  },

  /**
   * Get user dashboard statistics
   */
  async getDashboardStats(): Promise<DashboardStats> {
    const response = await api.get('/auth/dashboard-stats');
    return response.data;
  },
};

